import { render, staticRenderFns } from "./identification_submission.vue?vue&type=template&id=beea94d0&scoped=true"
import script from "./identification_submission.vue?vue&type=script&lang=js"
export * from "./identification_submission.vue?vue&type=script&lang=js"
import style0 from "./identification_submission.vue?vue&type=style&index=0&id=beea94d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beea94d0",
  null
  
)

export default component.exports